import { useEffect, useState } from 'react';
import {
  COLUMN_VISIBILITY_STORAGE_KEY,
  type ColumnVisibilityState,
  type HubspotColumnKey,
  normalizeColumnVisibility,
} from '../../lib/hubspot-management/columnVisibility';
import { captureAndReportError } from '../../utils/errorReporting';
import { safeLocalStorage } from '../../utils/safeLocalStorage';

export function useHubspotColumnVisibility() {
  const [columnVisibility, setColumnVisibility] =
    useState<ColumnVisibilityState>(() => {
      try {
        const stored = safeLocalStorage.getItem(COLUMN_VISIBILITY_STORAGE_KEY);
        if (stored) {
          return normalizeColumnVisibility(JSON.parse(stored));
        }
      } catch (error) {
        captureAndReportError(error, {
          operation: 'hubspot.loadColumnVisibility',
          component: 'HubspotManagementPage',
        });
      }

      return normalizeColumnVisibility(null);
    });

  useEffect(() => {
    safeLocalStorage.setItem(
      COLUMN_VISIBILITY_STORAGE_KEY,
      JSON.stringify(columnVisibility),
    );
  }, [columnVisibility]);

  const handleColumnVisibilityChange = (
    key: HubspotColumnKey,
    checked: boolean,
  ) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  return {
    columnVisibility,
    setColumnVisibility,
    handleColumnVisibilityChange,
  };
}
